<template>
    <EventsList v-if="!showDetails" @edit="editEvent" />
    <EventDetails
        v-else
        :event="eventToEdit"
        :tickerEvent="tickerEventToEdit"
        :backupData="backupData"
        @save="save"
        @cancel="cancel"
    />
</template>

<script>
import { mapState, mapActions, mapMutations } from "vuex";
import EventsList from "./events/EventsList.vue";
import EventDetails from "./events/EventDetails.vue";
import { useBackupData } from "@/shared/utils/forms/useBackupData";
import { useCleanQueryParams } from "@/shared/utils/router/useCleanQueryParams";
import { tickersService } from "@/apps/ticker/services/tickers.service";

export default {
    components: {
        EventsList,
        EventDetails,
    },
    setup() {
        const { cleanQueryParams } = useCleanQueryParams();
        const { backupData, setBackupValue } = useBackupData({});
        return { backupData, setBackupValue, cleanQueryParams };
    },
    mounted() {
        this.$watch(() => this.$route.query.open, this.handleQueryChange, {
            immediate: true,
        });
    },
    data() {
        return {
            showDetails: false,
            eventToEdit: {},
            tickerEventToEdit: {},
        };
    },
    computed: {
        ...mapState("ticker", ["ticker", "events"]),
    },
    methods: {
        ...mapMutations("ticker", ["addEvent", "changeEvent"]),
        ...mapActions("ticker", ["saveSnapshot"]),
        ...mapActions("alert", ["showWarnMessage"]),
        editEvent(event) {
            this.eventToEdit = event;
            let tickerEvent = this.events.find((e) => e.code === event.code);
            if (!tickerEvent) {
                this.addEvent(event.code);
                tickerEvent = this.events.find((e) => e.code === event.code);
            }
            this.tickerEventToEdit = tickerEvent;
            this.setBackupValue(tickerEvent);
            this.showDetails = true;
        },
        async cancel() {
            this.changeEvent(this.backupData);
            await this.saveSnapshot();
            this.showDetails = false;
        },
        async save() {
            if (!this.tickerEventToEdit._created && !this.tickerEventToEdit._deleted) {
                this.tickerEventToEdit._changed = true;
            }
            await this.saveSnapshot();
            this.showDetails = false;
        },
        handleQueryChange() {
            if (this.$route.query.open === "edit-event") {
                const eventCode = this.$route.query.id;

                setTimeout(() => {
                    this.cleanQueryParams(["open", "id"]);
                }, 100);

                const eventTypes = tickersService.getEventTypes().value;

                const event = eventTypes.find((e) => e.code === eventCode);

                if (!event) {
                    return;
                }
                if (this.showDetails && this.eventToEdit.code !== eventCode) {
                    this.showWarnMessage({
                        message: this.$t("faq.questions.unsaved_changes_question"),
                    });

                    return;
                }

                this.editEvent(event);
            }
        },
    },
};
</script>
